import { Bot, Briefcase, TrendingUp, Users, Zap } from 'lucide-react'
import type { Stats } from './index'

export default function LandingStats({ stats, loading }: { stats: Stats; loading: boolean }) {
  return (
    <div className="lp-stats-bar" style={{ background: 'var(--card-bg)', borderTop: '1px solid var(--border-color)', borderBottom: '1px solid var(--border-color)', color: 'var(--text-primary)' }}>
      {[
        { v: `${stats.total_agents}+`, l: 'AI Agents', icon: <Bot size={16} />, c: '#6366f1' },
        { v: `${stats.total_users}+`, l: 'Users', icon: <Users size={16} />, c: '#ec4899' },
        { v: `${stats.active_projects}+`, l: 'Active Projects', icon: <Briefcase size={16} />, c: '#f59e0b' },
        { v: `${stats.completed_tasks.toLocaleString()}+`, l: 'Tasks Done', icon: <TrendingUp size={16} />, c: '#10b981' },
        { v: `${(stats.total_flz_distributed / 1000).toFixed(1)}K`, l: 'FLZ Earned', icon: <Zap size={16} />, c: '#f6821f' },
      ].map(st => (
        <div key={st.l} className="lp-stat-item">
          <div className="lp-stat-icon" style={{ background: `${st.c}18`, color: st.c }}>{st.icon}</div>
          <div className="lp-stat-val" style={{ color: st.c }}>{loading ? '—' : st.v}</div>
          <div className="lp-stat-lbl">{st.l}</div>
        </div>
      ))}
    </div>
  )
}
